












































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import OfferDetails from "@/models/OfferDetails";
import SubmissionFormStatementsItem from "./SubmissionFormStatementsItem.vue";

@Component({
  components: {
    SubmissionFormStatementsItem
  }
})
export default class SubmissionFormStatements extends Vue {
  @Prop() private offerDetails!: OfferDetails;
  @Emit()
  statementsChange() {
    let result = true;
    this.$children
      .filter(val => {
        return val instanceof SubmissionFormStatementsItem;
      })
      .forEach(val => {
        if (!(val as SubmissionFormStatementsItem).checked) result = false;
      });
    return result;
  }
}
